import { useUISlice } from "@/models/useUISlice";
import { useTranslation } from "react-i18next";
import { gotoPrivacy } from "@/product-links";
import ModalContainer from "@/components/ModalContainer";

const AlertModal = () => {
  const { t } = useTranslation();
  const modal = useUISlice((state) => state.alertModal);
  const setModal = useUISlice((state) => state.setAlertModal);

  if (!modal) return null;

  return (
    <ModalContainer
      className={modal.className}
      title={modal.title}
      loading={modal.loading}
      subtitle={modal.subtitle}
      onLeftButtonPress={modal.onLeftButtonPress}
      onDismiss={modal.onDismiss || (() => setModal(undefined))}
      shouldPersistBackdropClick={modal.shouldPersistBackdropClick}
      primaryButtonText={modal.button?.text}
      onPrimaryButtonPress={modal.button?.onPress}
      hideDismissIcon={modal.hideDismissIcon}
      hideCancel={!modal.cancelText || modal.hideCancel}
      cancelText={modal.cancelText}
      destructive={modal.button?.destructive}
      modalWidth={360}
    >
      {modal.privacyLink && (
        <button type="button" data-action-id="legal.privacy.open" onClick={gotoPrivacy}
          className="text-sm underline text-[var(--text-secondary)]">
          {t("settings.privacyPolicy")}
        </button>
      )}
    </ModalContainer>
  );
};

export default AlertModal;
